import { render, staticRenderFns } from "./FullScreenLayout.vue?vue&type=template&id=7a2ed081&scoped=true&"
import script from "./FullScreenLayout.vue?vue&type=script&lang=js&"
export * from "./FullScreenLayout.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenLayout.vue?vue&type=style&index=0&id=7a2ed081&lang=scss&scoped=true&"
import style1 from "./FullScreenLayout.vue?vue&type=style&index=1&id=7a2ed081&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2ed081",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a2ed081')) {
      api.createRecord('7a2ed081', component.options)
    } else {
      api.reload('7a2ed081', component.options)
    }
    module.hot.accept("./FullScreenLayout.vue?vue&type=template&id=7a2ed081&scoped=true&", function () {
      api.rerender('7a2ed081', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/FullScreenLayout.vue"
export default component.exports